var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-foot"},[_c('div',{staticClass:"foot-top"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"bottom-btns"},[_c('a',{staticClass:"btn-blue-hover",on:{"click":_vm.goTest}},[_vm._v("试用")]),_c('a',{on:{"click":_vm.chatShow}},[_vm._v("咨询顾问")])])]),_vm._v(" "),_c('us-pc-dialog',{attrs:{"dialogVisible":_vm.isPcDialogShow},on:{"cancel":function($event){_vm.isPcDialogShow = false}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"txt"},[_vm._v("\n      丈量，不可估量的未来"),_c('br'),_vm._v("\n      赛码，致力成为在线考试专业平台\n    ")])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/home/footer.vue?vue&type=template&id=0461929c&scoped=true
// module id = null
// module chunks = 